import { render, staticRenderFns } from "./JackpotPill.vue?vue&type=template&id=10d29cba&scoped=true&"
import script from "./JackpotPill.vue?vue&type=script&lang=js&"
export * from "./JackpotPill.vue?vue&type=script&lang=js&"
import style0 from "./JackpotPill.vue?vue&type=style&index=0&id=10d29cba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d29cba",
  null
  
)

export default component.exports